import React from 'react';
import {
  Scissors,
  Drop,
  Sparkle,
  Hand,
  Heart,
  PawPrint,
} from '@phosphor-icons/react';
import ServicePage from './ServicePage';

const facilities = [
  { icon: Drop, label: 'Warm-water baths', sub: 'Hypoallergenic, coat-specific shampoos' },
  { icon: Scissors, label: 'Coat trims', sub: 'Breed-appropriate styling' },
  { icon: Hand, label: 'Nail care', sub: 'Gentle trim and smoothing' },
  { icon: Sparkle, label: 'Ear & paw cleaning', sub: 'Soft, careful and pet-safe' },
  { icon: PawPrint, label: 'De-shedding', sub: 'Coat-friendly tools for low-stress sessions' },
  { icon: Heart, label: 'Calm handling', sub: 'Patient pace for anxious pets' },
];

const gallery = [
  {
    url: 'https://images.unsplash.com/photo-1644675443401-ea4c14bad0e6?auto=format&fit=crop&w=1200&q=80',
    title: 'Bath time',
    description: 'Warm water, gentle suds, careful hands.',
  },
  {
    url: 'https://images.pexels.com/photos/4587991/pexels-photo-4587991.jpeg?auto=compress&cs=tinysrgb&w=1200',
    title: 'Coat care',
    description: 'Styling that suits each breed.',
  },
  {
    url: 'https://images.unsplash.com/photo-1591946614720-90a587da4a36?auto=format&fit=crop&w=1200&q=80',
    title: 'Finishing touches',
    description: 'Brush, dry and a soft-scented finish.',
  },
];

const highlights = [
  'Non-slip bathing stations sized for every dog',
  'Quiet dryers for sound-sensitive pets',
  'Pre-groom check for skin and coat health',
  'Pet-safe, paraben-free products only',
];

const Grooming = () => (
  <ServicePage
    eyebrow="Grooming"
    title="Spa days, made for dogs"
    lede="Full grooming and styling sessions in a calm, well-equipped space — with patience built in."
    heroImage="https://images.unsplash.com/photo-1591946614720-90a587da4a36?auto=format&fit=crop&w=2000&q=80"
    heroAlt="Dog being groomed at a spa"
    intro="From a quick freshen-up to a full coat trim, our groomers work at your dog’s pace. Sessions are structured to be calm, predictable and gentle from the first wash to the final brush-out."
    facilities={facilities}
    gallery={gallery}
    highlights={highlights}
    closingTitle="Clean, calm and looking sharp"
    closingBody="Grooming should feel good. Our space, tools and people are chosen so every visit ends with a happy, easy-going pet."
  />
);

export default Grooming;
